import React from 'react'
import { Route, Switch } from 'react-router'
import ReportVehiclePerformance from './ReportVehiclePerformance'

const Components = props => (
    <Switch>
        <Route exact path={`${props.match.url}/:year?`} component={ReportVehiclePerformance} />
    </Switch>
)

export default Components
